// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__x2QDa","image":"App_image__3-HeK"};